function getCspNonce() {
  const cspNonce = "document" in globalThis
    ? document.querySelector<HTMLMetaElement>("meta[property=csp-nonce]")?.nonce
    : undefined;

  return cspNonce;
}

export const cspNonce = getCspNonce();
